import { z } from 'zod'

export const plansContextSearchSchema = z.object({
  view: z.enum(['list', 'tiles']).optional(),
  folder: z.string().optional(),
  // list header sorting; free strings on purpose: usePlanMenuListSorting
  // drops unknown values, so a hand-edited url falls back instead of erroring
  sort: z.string().optional(),
  dir: z.string().optional()
})

// `destinationFolderId` preselects the folder the import lands in (the folder
// the user is in, or the one picked in the context menu). Master keeps it as an
// optional positional segment (`/import/:destinationFolderId?`).
export const plansImportSearchSchema = plansContextSearchSchema.extend({
  destinationFolderId: z.string().optional()
})

export const plansNewFolderSearchSchema = plansContextSearchSchema.extend({
  parentId: z.string().optional()
})

export const plansRenameSearchSchema = plansContextSearchSchema.extend({
  id: z.string().optional(),
  parentId: z.string().optional(),
  name: z.string().optional(),
  type: z.enum(['folder', 'plan']).optional()
})

// `destinationFolderId` is the drag-and-drop shortcut: when present the modal
// submits the move immediately instead of asking for a destination. Master kept
// it as an optional positional segment (`/move/:itemId/:destinationFolderId?`);
// here it is a search param, matching how every other optional tail was migrated.
export const plansMoveSearchSchema = plansContextSearchSchema.extend({
  destinationFolderId: z.string().optional()
})

export const plansImportRevisionSearchSchema = plansContextSearchSchema.extend({
  option: z.enum(['selectPage', 'compare']).optional()
})

export const planVersionsRevisionSearchSchema = z.object({
  show: z.string().optional()
})
